// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* BORDERS */\n\n/* Icons */\n\n/* BORDERS */\n\n/* Icons */\n.square[data-v-9495fd20] {\n  padding: 0 !important;\n  min-width: 36px !important;\n}", ""]);
// Exports
module.exports = exports;
